import { gql } from 'src/__generated__';

const FETCH_LAST_DISTRIBUTION_BY_ICN = gql(`
  query FetchLastDistributionInstanceByICN($irrigationChannelNetworkId: Int!) {
    latestSiraDistributionInstance(irrigationChannelNetworkId: $irrigationChannelNetworkId) {
      id
      title
      source
      ownerFirstname
      ownerLastname
      irrigationChannelNetworkId
      distributionWaterFlow
      distributionLossValue
      distributionLossUnit
      siraDistributionId
      distributionStartDate
      sendDate
      canals {
        id
        name
        shares
        actualDistributionFlow
        inletDevice {
          id
        }
      }
    }
  }
`);

export default FETCH_LAST_DISTRIBUTION_BY_ICN;
